module.exports = __webpack_public_path__ + "media/images/home/logo3_small-906269b31f0bb01f7a3d08ba8a1312bb.png";